const nameValidation = (value) => {
  let error;
  if (!value) {
    error = "validation.name_is_required";
  }
  return error;
};
const hardwareValidation = (_value, values, t) => {
  const isNB = values.network_type === "NB";
  const isDendrometer = values.sensor_type === "dendrometer_sensor";
  const imeiLimit = 15;
  const serialLimit = 16;

  if (isNB && !isDendrometer) {
    if (!_value || _value.length !== imeiLimit) {
      return t(`validation.imei_must_be_${imeiLimit}_digits`);
    }
  } else {
    if (!_value || _value.length !== serialLimit) {
      return t(`validation.hardware_serial_must_be_${serialLimit}_characters`);
    }
  }

  return undefined;
};

export const validation = {
  nameValidation,
  hardwareValidation,
};
